import { MembreRelation } from './MembreRelation.class';
/**
 * Chaque objet est un lien unissant deux membres
 */
export class MembreContact extends MembreRelation {
    /**
     * Constructeur de l'objet MembreContact
     * @param contact contient les données de l'objet
     */
    constructor(contact) {
        if (contact) {
            const { idMembreContact, idExpediteur, idRecepteur, dateDemande, dateDebutContact, status } = contact;
            super({
                idRelation: idMembreContact,
                idExpediteur,
                idRecepteur,
            });
            this.dateDemande = dateDemande;
            this.dateDebutContact = dateDebutContact;
            this.status = status;
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWVtYnJlQ29udGFjdC5jbGFzcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIk1lbWJyZUNvbnRhY3QuY2xhc3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLHdCQUF3QixDQUFDO0FBRXhEOztHQUVHO0FBQ0gsTUFBTSxPQUFPLGFBQWMsU0FBUSxjQUFjO0lBK0JoRDs7O09BR0c7SUFDSCxZQUFtQixPQUFnQztRQUNsRCxJQUFJLE9BQU8sRUFBRTtZQUNaLE1BQU0sRUFBRSxlQUFlLEVBQUUsWUFBWSxFQUFFLFdBQVcsRUFBRSxXQUFXLEVBQUUsZ0JBQWdCLEVBQUUsTUFBTSxFQUFFLEdBQUcsT0FBTyxDQUFDO1lBRXRHLEtBQUssQ0FBQztnQkFDTCxVQUFVLEVBQUUsZUFBZTtnQkFDM0IsWUFBWTtnQkFDWixXQUFXO2FBQ1gsQ0FBQyxDQUFDO1lBRUgsSUFBSSxDQUFDLFdBQVcsR0FBRyxXQUFXLENBQUM7WUFDL0IsSUFBSSxDQUFDLGdCQUFnQixHQUFHLGdCQUFnQixDQUFDO1lBQ3pDLElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFDO1NBQ3JCO0lBQ0YsQ0FBQztDQUNEIn0=